import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { HotelSelectionDialogComponent, HotelSelectionDialogData, HotelSelectionNavigation } from '../../components/hotel-selection-dialog/hotel-selection-dialog.component';
import { CardValidityDialogComponent } from '../../components/card-validity-dialog/card-validity-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class DialogService {
  constructor(
    private dialog: MatDialog
  ) {}

  openHotelSelectionDialog(options?: {
    disableClose?: boolean;
    preloadedData?: HotelSelectionDialogData;
    /** Defaults to 'reload'; HotelSelectionGuard passes 'guard' and navigates itself */
    navigation?: HotelSelectionNavigation;
  }): MatDialogRef<HotelSelectionDialogComponent> {
    const data: HotelSelectionDialogData = {
      ...(options?.preloadedData ?? {}),
      navigation: options?.navigation ?? 'reload',
    };

    return this.dialog.open(HotelSelectionDialogComponent, {
      width: '1183px',
      maxWidth: '90vw',
      height: '80vh',
      panelClass: 'hotel-selection-dialog-panel',
      backdropClass: 'transparent-backdrop',
      disableClose: options?.disableClose ?? false,
      data,
    });
  }

  openCardValidityDialog(): MatDialogRef<CardValidityDialogComponent> {
    return this.dialog.open(CardValidityDialogComponent, {
      width: '478px',
      maxWidth: 'calc(100vw - 32px)',
      panelClass: 'card-validity-dialog-panel',
      backdropClass: 'dialog-backdrop',
      hasBackdrop: true,
      disableClose: true,
    });
  }
}
